<template>
  <div
    ref="cropperBox"
    class="cropper-box"
  >
    <div
      class="cut-side"
      :style="{ left: cutSideRect.x + 'px', top: cutSideRect.y + 'px', width: cutSideRect.width + 'px', height: cutSideRect.height + 'px' }"
    >
      <slot></slot>
      <div
        id="cutWindow"
        ref="cutWindow"
        class="cut-window"
        :style="{ left: cutWindowRect.x + 'px', top: cutWindowRect.y + 'px', width: cutWindowRect.width + 'px', height: cutWindowRect.height + 'px' }"
        @mousedown="cut_window_mousedown"
      >
        <div
          :data-action="ACTION_WEST"
          class="west-side"
        >
          <!-- <div></div> -->
        </div>
        <div
          :data-action="ACTION_NORTH"
          class="north-side"
        >
          <!-- <div></div> -->
        </div>
        <div
          :data-action="ACTION_EAST"
          class="esat-side"
        >
          <!-- <div></div> -->
        </div>
        <div
          :data-action="ACTION_SOUTH"
          class="south-side"
        >
          <!-- <div></div> -->
        </div>

        <div
          :data-action="ACTION_WEST_NORTH"
          class="west-north-side"
        ></div>
        <div
          :data-action="ACTION_EAST_NORTH"
          class="east-north-side"
        ></div>
        <div
          :data-action="ACTION_EAST_SOUTH"
          class="east-south-side"
        ></div>
        <div
          :data-action="ACTION_WEST_SOUTH"
          class="west-south-side"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CropperBox',
  components: {},
  model: {
    prop: 'cutPost',
    event: 'cutChanged'
  },
  props: {
    cutRect: Object,
    ratio: {
      type: Number,
      default: -1
    },
    rotate: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      cutMode: 'none', //none move zoom
      cutModeCode: {
        none: 'none',
        move: 'move',
        zoom: 'zoom'
      },
      targetElement: null, //待裁剪的元素
      targetW: 0, //待裁剪的元素实际宽度
      targetH: 0, //待裁剪的元素实际高度
      ACTION_EAST: 'e',
      ACTION_WEST: 'w',
      ACTION_SOUTH: 's',
      ACTION_NORTH: 'n',
      ACTION_EAST_NORTH: 'ne',
      ACTION_WEST_NORTH: 'nw',
      ACTION_EAST_SOUTH: 'se',
      ACTION_WEST_SOUTH: 'sw',
      ACTION_WEST_SIDE: 'w-side',
      ACTION_NORTH_SIDE: 'n-side',
      ACTION_EAST_SIDE: 'e-side',
      ACTION_SOUTH_SIDE: 's-side',
      cutWindowRect: { x: 0, y: 0, width: 0, height: 0 },
      cutSideRect: { x: 0, y: 0, width: 0, height: 0 },

      cutRation: -1
    };
  },
  computed: {},
  watch: {
    rotate() {
      this.initCutTargetPosition();
      this.initCutSize();
    },
    ratio() {
      this.initCutSize();
    }
  },
  mounted() {
    this.$nextTick(() => {
      let slot = this.$slots.default[0];
      if (slot.tag == 'video') {
        this.targetElement = slot.elm;
        this.targetElement.onloadedmetadata = () => {
          //this.targetW = this.targetElement.videoWidth;
          //this.targetH = this.targetElement.videoHeight;
          this.initCutTargetPosition();
          this.initCutSize();
        };
      }
    });
    window.onresize = () => {
      this.initCutTargetPosition();
      this.initCutSize();
    };
  },
  methods: {
    cutChanged(rect) {
      let sceleX = this.targetW / this.cutSideRect.width;
      let scaleY = this.targetH / this.cutSideRect.height;
      let obj = {};

      obj.width = rect.width * sceleX;
      obj.height = rect.height * scaleY;
      obj.x = rect.x * sceleX;
      obj.y = rect.y * scaleY;

      //console.log(`videoW:${this.targetW} videoH:${this.targetH} x:${obj.x}  y:${obj.y} width:${obj.width} height:${obj.height}`);
      this.$emit('cutChanged', obj);
    },
    cut_window_mousedown(e) {
      e.preventDefault();
      if (e.target.id == 'cutWindow') {
        this.cutMode = this.cutModeCode.move;
        this.moveCutWindow(e);
      } else {
        this.cutMode = this.cutModeCode.zoom;
        this.zoomCutWindow(e);
      }
    },
    moveCutWindow(e) {
      let cutWindow = e.target;
      let parentElement = cutWindow.parentElement;
      //得到当前鼠标的位置
      let firstMouseX = e.clientX;
      let firstMouseY = e.clientY;
      //得到当前元素距离父元素的top和left值
      let firstLeft = cutWindow.offsetLeft;
      let firstTop = cutWindow.offsetTop;
      //当鼠标按下且移动的时候

      document.onmousemove = null;
      document.onmousemove = (e) => {
        //得到当前鼠标最新的位置
        let nowX = e.clientX;
        let nowY = e.clientY;
        //算法 鼠标最新的位置-鼠标一开始的位置 得到应该移动的距离  + 元素一开始的位置 =最新的位置
        let resultX = nowX - firstMouseX + firstLeft;
        let resultY = nowY - firstMouseY + firstTop;

        if (resultX < 0) {
          resultX = 0;
        } else if (resultX > parentElement.clientWidth - cutWindow.clientWidth) {
          resultX = parentElement.clientWidth - cutWindow.clientWidth;
        }
        if (resultY < 0) {
          resultY = 0;
        } else if (resultY > parentElement.clientHeight - cutWindow.clientHeight) {
          resultY = parentElement.clientHeight - cutWindow.clientHeight;
        }

        this.cutWindowRect.x = resultX;
        this.cutWindowRect.y = resultY;
      };
      document.onmouseup = () => {
        document.onmousemove = null;
        if (this.cutMode == this.cutModeCode.none) {
          return;
        }
        this.cutMode = this.cutModeCode.none;
        this.cutChanged(this.cutWindowRect);
      };
    },

    zoomCutWindow(e) {
      let actionId = e.target.dataset.action;
      let cutWindow = e.target.parentElement; //裁剪框对象
      let cutRect = {
        x: this.cutWindowRect.x,
        y: this.cutWindowRect.y,
        width: this.cutWindowRect.width,
        height: this.cutWindowRect.height
      };

      let cutInfo = {
        cutRect: cutRect,
        cutClientRect: cutWindow.getBoundingClientRect(), //用来算鼠标偏移
        sideRect: this.cutSideRect,
        ratio: this.cutRation,
        diagonalX: 0,
        diagonalY: 0
      };

      let newtRect = {
        x: this.cutWindowRect.x,
        y: this.cutWindowRect.y,
        width: this.cutWindowRect.width,
        height: this.cutWindowRect.height
      };
      document.onmousemove = null;
      document.onmousemove = (e) => {
        e.preventDefault();
        switch (actionId) {
          case this.ACTION_EAST:
            //newtRect = this.drag_E(e, cutInfo);
            newtRect = this.action_east(e, cutInfo);
            break;
          case this.ACTION_SOUTH:
            newtRect = this.action_south(e, cutInfo);
            //newtRect = this.drag_S(e, cutInfo);
            break;
          case this.ACTION_WEST:
            //newtRect = this.drag_W(e, cutInfo);
            newtRect = this.action_west(e, cutInfo);
            break;
          case this.ACTION_NORTH:
            //newtRect = this.drag_N(e, cutInfo);
            newtRect = this.action_north(e, cutInfo);
            break;
          case this.ACTION_EAST_SOUTH:
            //newtRect = this.drag_E_S(e, cutInfo);
            newtRect = this.action_east_south(e, cutInfo);
            break;
          case this.ACTION_EAST_NORTH:
            //newtRect = this.drag_E_N(e, cutInfo);
            newtRect = this.action_east_north(e, cutInfo);
            break;
          case this.ACTION_WEST_SOUTH:
            //newtRect = this.drag_W_S(e, cutInfo);
            newtRect = this.action_west_south(e, cutInfo);
            break;
          case this.ACTION_WEST_NORTH:
            //newtRect = this.drag_W_N(e, cutInfo);
            newtRect = this.action_west_north(e, cutInfo);
            break;
        }
        this.cutWindowRect = newtRect || this.cutWindowRect;
      };
      document.onmouseup = () => {
        document.onmousemove = null;
        if (this.cutMode == this.cutModeCode.none) {
          return;
        }
        this.cutMode = this.cutModeCode.none;
        this.positionCheck(cutInfo);
        this.cutChanged(this.cutWindowRect);
      };
    },

    positionCheck(cutInfo) {
      let rect = this.cutWindowRect;
      let x = rect.x;
      let y = rect.y;
      let width = rect.width;
      let height = rect.height;

      if (rect.width < 60 && rect.width <= rect.height) {
        //当width小于6并且是短边时
        width = 60;
        height = width / cutInfo.ratio;
        x = rect.x + (rect.width - width) / 2;
        y = rect.y + (rect.height - height) / 2;
        //this.cutWindowRect = { x: x < 0 ? 0 : x, y: y < 0 ? 0 : y, width: width, height: height };
      } else if (rect.height < 60 && rect.height <= rect.width) {
        height = 60;
        width = height * cutInfo.ratio;
        x = rect.x + (rect.width - width) / 2;
        y = rect.y + (rect.height - height) / 2;

        //this.cutWindowRect = { x: x < 0 ? 0 : x, y: y < 0 ? 0 : y, width: width, height: height };
      }
      if (x + width > this.cutSideRect.width) {
        x = this.cutSideRect.width - width;
      }
      if (x < 0) {
        x = 0;
      }
      if (y + height > this.cutSideRect.height) {
        y = this.cutSideRect.height - height;
      }
      if (y < 0) {
        y = 0;
      }

      this.cutWindowRect = { x: x, y: y, width: width, height: height };
    },

    //水平方向
    freeRatioHorizontal(e, cutInfo) {
      //算法：知道矩形框对角线上的2个角，就能得到矩形框的位置大小信息
      //在拖拽操作中，“拖拽角”所对应的“对角”的坐标永远是是固定的
      let cutRect = cutInfo.cutRect;
      let sideRect = cutInfo.sideRect;
      //固定角坐标
      let diagonalX = cutInfo.diagonalX;
      //移动距离 = 鼠标当前位置 -鼠标起始位置
      let moveX = e.clientX - cutInfo.cutClientRect.x;
      //活动角坐标
      let nowX = cutRect.x + moveX;
      //判断边界
      if (nowX < 0) {
        nowX = 0;
      } else if (nowX > sideRect.width) {
        nowX = sideRect.width;
      }
      let x = nowX < diagonalX ? nowX : diagonalX;
      let width = Math.abs(nowX - diagonalX);

      return { x: x, width: width };
    },
    //竖直方向
    freeRatioVertical(e, cutInfo) {
      //算法：知道矩形框对角线上的2个角，就能得到矩形框的位置大小信息
      //在拖拽操作中，“拖拽角”所对应的“对角”的坐标永远是是固定的
      let cutRect = cutInfo.cutRect;
      let sideRect = cutInfo.sideRect;
      //固定角坐标
      let diagonalY = cutInfo.diagonalY;
      //移动距离 = 鼠标当前位置 -鼠标起始位置
      let moveY = e.clientY - cutInfo.cutClientRect.y;
      //活动角坐标
      let nowY = cutRect.y + moveY;
      //判断边界
      if (nowY < 0) {
        nowY = 0;
      } else if (nowY > sideRect.height) {
        nowY = sideRect.height;
      }

      let y = nowY < diagonalY ? nowY : diagonalY;
      let height = Math.abs(nowY - diagonalY);
      return { y: y, height: height };
    },
    //对角线方向
    freeRatioDiagonal(e, cutInfo) {
      //算法：知道矩形框对角线上的2个角，就能得到矩形框的位置大小信息
      //在拖拽操作中，“拖拽角”所对应的“对角”的坐标永远是是固定的
      let cutRect = cutInfo.cutRect;
      let sideRect = cutInfo.sideRect;
      // let ratio = cutInfo.ratio;
      //固定角坐标
      let diagonalX = cutInfo.diagonalX;
      let diagonalY = cutInfo.diagonalY;
      //移动距离 = 鼠标当前位置 -鼠标起始位置
      let moveX = e.clientX - cutInfo.cutClientRect.x;
      let moveY = e.clientY - cutInfo.cutClientRect.y;

      //活动角坐标
      let nowX = cutRect.x + moveX;
      let nowY = cutRect.y + moveY;
      //判断边界
      if (nowX < 0) {
        nowX = 0;
      } else if (nowX > sideRect.width) {
        nowX = sideRect.width;
      }
      if (nowY < 0) {
        nowY = 0;
      } else if (nowY > sideRect.height) {
        nowY = sideRect.height;
      }

      let x = nowX < diagonalX ? nowX : diagonalX;
      let y = nowY < diagonalY ? nowY : diagonalY;
      let width = Math.abs(nowX - diagonalX);
      let height = Math.abs(nowY - diagonalY);

      return { x: x, y: y, width: width, height: height };
    },

    //水平方向
    fixedRatioHorizontal(e, cutInfo) {
      let cutRect = cutInfo.cutRect;
      let sideRect = cutInfo.sideRect;
      let ratio = cutInfo.ratio;
      //固定角坐标
      let diagonalX = cutInfo.diagonalX;
      // 在y方向可同比例放大的最大高度
      let maxHeight1 = cutRect.y * 2 + cutRect.height;
      let maxHeight2 = (sideRect.height - (cutRect.y + cutRect.height)) * 2 + cutRect.height;
      let maxHeight = maxHeight1 < maxHeight2 ? maxHeight1 : maxHeight2;
      //移动距离 = 鼠标当前位置 -鼠标起始位置
      let moveX = e.clientX - cutInfo.cutClientRect.x;

      //活动角坐标
      let nowX = cutRect.x + moveX;
      // let nowY = cutRect.y + moveY;
      //判断边界
      if (nowX < 0) {
        nowX = 0;
      } else if (nowX > sideRect.width) {
        nowX = sideRect.width;
      }

      let x = nowX < diagonalX ? nowX : diagonalX;
      let width = Math.abs(nowX - diagonalX);
      let height = width / ratio;

      if (height > maxHeight) {
        height = maxHeight;
        width = height * ratio;
        x = nowX < diagonalX ? diagonalX - width : diagonalX;
      }
      let y = cutRect.y + (cutRect.height - height) / 2;

      return { x: x, y: y, width: width, height: height };
    },

    fixedRatioVertical(e, cutInfo) {
      let cutRect = cutInfo.cutRect;
      let sideRect = cutInfo.sideRect;
      let ratio = cutInfo.ratio;
      //固定角坐标
      let diagonalY = cutInfo.diagonalY;
      // 在x方向可同比例放大的最大宽度
      let maxWidth1 = cutRect.x * 2 + cutRect.width;
      let maxWidth2 = (sideRect.width - (cutRect.x + cutRect.width)) * 2 + cutRect.width;
      let maxWidth = maxWidth1 < maxWidth2 ? maxWidth1 : maxWidth2;
      //移动距离 = 鼠标当前位置 -鼠标起始位置
      let moveY = e.clientY - cutInfo.cutClientRect.y;

      //活动角坐标
      let nowY = cutRect.y + moveY;
      // let nowY = cutRect.y + moveY;
      //判断边界
      if (nowY < 0) {
        nowY = 0;
      } else if (nowY > sideRect.height) {
        nowY = sideRect.height;
      }

      let y = nowY < diagonalY ? nowY : diagonalY;
      let height = Math.abs(nowY - diagonalY);
      let width = height * ratio;

      if (width > maxWidth) {
        width = maxWidth;
        height = width / ratio;
        y = nowY < diagonalY ? diagonalY - height : diagonalY;
      }
      let x = cutRect.x + (cutRect.width - width) / 2;

      return { x: x, y: y, width: width, height: height };
    },
    //对角固定比例
    fixedRatioDiagonal(e, cutInfo) {
      //算法：知道矩形框对角线上的2个角，就能得到矩形框的位置大小信息
      //在拖拽操作中，“拖拽角”所对应的“对角”的坐标永远是是固定的
      let cutRect = cutInfo.cutRect;
      let sideRect = cutInfo.sideRect;
      let ratio = cutInfo.ratio;
      //固定角坐标
      let diagonalX = cutInfo.diagonalX;
      let diagonalY = cutInfo.diagonalY;
      // 在y方向可同比例放大的最大高度
      // let maxHeight1 = cutRect.y + cutRect.height;
      // let maxHeight2 = sideRect.height - (cutRect.y + cutRect.height) + cutRect.height;
      // let maxHeight = maxHeight1 < maxHeight2 ? maxHeight2 : maxHeight1;

      //移动距离 = 鼠标当前位置 -鼠标起始位置
      let moveX = e.clientX - cutInfo.cutClientRect.x;
      let moveY = e.clientY - cutInfo.cutClientRect.y;

      //活动角坐标
      let nowX = cutRect.x + moveX;
      let nowY = cutRect.y + moveY;
      //判断边界
      if (nowX < 0) {
        nowX = 0;
      } else if (nowX > sideRect.width) {
        nowX = sideRect.width;
      }
      if (nowY <= 0) {
        nowY = 0;
      } else if (nowY > sideRect.height) {
        nowY = sideRect.height;
      }

      let x = nowX < diagonalX ? nowX : diagonalX;
      let width = Math.abs(nowX - diagonalX);
      let height = width / ratio;
      let y = nowY < diagonalY ? diagonalY - height : diagonalY;
      if (y < 0) {
        y = 0;
        height = diagonalY;
        width = height * ratio;
        x = nowX < diagonalX ? diagonalX - width : diagonalX;
        //console.log(`x:${x}  y:${y} width:${width} height:${height}`);
      } else if (y + height > sideRect.height) {
        height = sideRect.height - diagonalY;
        width = height * ratio;
        x = nowX < diagonalX ? diagonalX - width : diagonalX;
      }
      //console.log(`x:${x}  y:${y} width:${width} height:${height}`);
      // if (height > maxHeight) {
      //   height = maxHeight;
      //   width = height * ratio;
      //   x = nowX < diagonalX ? diagonalX - width : diagonalX;
      // }

      return { x: x, y: y, width: width, height: height };
    },

    action_north(e, cutInfo) {
      let cutRect = cutInfo.cutRect;
      cutInfo.diagonalY = cutRect.y + cutRect.height;
      cutInfo.diagonalX = cutRect.x + cutRect.width / 2;
      if (cutInfo.ratio == -1) {
        let result = this.freeRatioVertical(e, cutInfo);
        return { x: cutRect.x, y: result.y, width: cutRect.width, height: result.height };
      } else {
        return this.fixedRatioVertical(e, cutInfo);
      }
    },
    action_east(e, cutInfo) {
      let cutRect = cutInfo.cutRect;
      cutInfo.diagonalX = cutRect.x;
      cutInfo.diagonalY = cutRect.y + cutRect.height / 2;
      if (cutInfo.ratio == -1) {
        let result = this.freeRatioHorizontal(e, cutInfo);
        return { x: result.x, y: cutRect.y, width: result.width, height: cutRect.height };
      } else {
        return this.fixedRatioHorizontal(e, cutInfo);
      }
    },
    action_south(e, cutInfo) {
      let cutRect = cutInfo.cutRect;
      cutInfo.diagonalX = cutRect.x + cutRect.width / 2;
      cutInfo.diagonalY = cutRect.y;
      if (cutInfo.ratio == -1) {
        let result = this.freeRatioVertical(e, cutInfo);
        return { x: cutRect.x, y: result.y, width: cutRect.width, height: result.height };
      } else {
        return this.fixedRatioVertical(e, cutInfo);
      }
    },
    action_west(e, cutInfo) {
      let cutRect = cutInfo.cutRect;
      cutInfo.diagonalX = cutRect.x + cutRect.width;
      cutInfo.diagonalY = cutRect.y + cutRect.height / 2;
      if (cutInfo.ratio == -1) {
        let result = this.freeRatioHorizontal(e, cutInfo);
        return { x: result.x, y: cutRect.y, width: result.width, height: cutRect.height };
      } else {
        return this.fixedRatioHorizontal(e, cutInfo);
      }
    },
    action_east_north(e, cutInfo) {
      cutInfo.diagonalX = cutInfo.cutRect.x;
      cutInfo.diagonalY = cutInfo.cutRect.y + cutInfo.cutRect.height;
      if (cutInfo.ratio == -1) {
        return this.freeRatioDiagonal(e, cutInfo);
      } else {
        return this.fixedRatioDiagonal(e, cutInfo);
      }
    },
    action_east_south(e, cutInfo) {
      cutInfo.diagonalX = cutInfo.cutRect.x;
      cutInfo.diagonalY = cutInfo.cutRect.y;
      if (cutInfo.ratio == -1) {
        return this.freeRatioDiagonal(e, cutInfo);
      } else {
        return this.fixedRatioDiagonal(e, cutInfo);
      }
    },
    action_west_south(e, cutInfo) {
      cutInfo.diagonalX = cutInfo.cutRect.x + cutInfo.cutRect.width;
      cutInfo.diagonalY = cutInfo.cutRect.y;
      if (cutInfo.ratio == -1) {
        return this.freeRatioDiagonal(e, cutInfo);
      } else {
        return this.fixedRatioDiagonal(e, cutInfo);
      }
    },
    action_west_north(e, cutInfo) {
      cutInfo.diagonalX = cutInfo.cutRect.x + cutInfo.cutRect.width;
      cutInfo.diagonalY = cutInfo.cutRect.y + cutInfo.cutRect.height;

      if (cutInfo.ratio == -1) {
        return this.freeRatioDiagonal(e, cutInfo);
      } else {
        return this.fixedRatioDiagonal(e, cutInfo);
      }
    },

    initCutSize() {
      let cutWidth = 0;
      let cutHeight = 0;
      this.cutRation = this.ratio;
      if (this.ratio == -1) {
        this.cutWindowRect = { x: 0, y: 0, width: this.cutSideRect.width, height: this.cutSideRect.height };
      } else if (this.ratio == 0) {
        this.cutRation = this.cutSideRect.width / this.cutSideRect.height;
        this.cutWindowRect = { x: 0, y: 0, width: this.cutSideRect.width, height: this.cutSideRect.height };
      } else {
        let cutSideRatio = this.cutSideRect.width / this.cutSideRect.height;
        if (this.ratio > cutSideRatio) {
          cutWidth = this.cutSideRect.width;
          cutHeight = cutWidth / this.cutRation;
        } else {
          cutHeight = this.cutSideRect.height;
          cutWidth = cutHeight * this.cutRation;
        }
        let x = (this.cutSideRect.width - cutWidth) / 2;
        let y = (this.cutSideRect.height - cutHeight) / 2;
        this.cutWindowRect = { x: x, y: y, width: cutWidth, height: cutHeight };
      }
      this.cutChanged(this.cutWindowRect);
    },
    initCutTargetPosition() {
      if (!this.targetElement || !this.$refs.cropperBox) return;
      //this.targetElement.style.transform = `rotate(${this.rotate}deg)`;
      if (this.rotate == 90 || this.rotate == 270) {
        this.targetW = this.targetElement.videoHeight;
        this.targetH = this.targetElement.videoWidth;
      } else {
        this.targetW = this.targetElement.videoWidth;
        this.targetH = this.targetElement.videoHeight;
      }

      let box = this.$refs.cropperBox.getBoundingClientRect();
      let maxW = box.width;
      let maxH = box.height;
      let containerRatio = box.width / box.height; //

      let tarRatio = this.targetW / this.targetH;

      let w = maxW;
      let h = maxH;
      //通过宽高比判断出视频元素在容器中的位置和大小
      if (tarRatio > containerRatio) {
        w = maxW;
        h = w / tarRatio;
      } else if (tarRatio < containerRatio) {
        h = maxH;
        w = h * tarRatio;
      }
      let x = (maxW - w) / 2;
      let y = (maxH - h) / 2;
      this.cutSideRect = { x: x, y: y, width: w, height: h };

      if (this.rotate == 90 || this.rotate == 270) {
        this.targetElement.style.width = h + 'px';
        this.targetElement.style.height = w + 'px';
        this.targetElement.style.top = (h - w) / 2 + 'px';
        this.targetElement.style.left = (w - h) / 2 + 'px';
        // this.targetElement.style.top = '0px';
        // this.targetElement.style.left = '0px';
      } else {
        this.targetElement.style.width = w + 'px';
        this.targetElement.style.height = h + 'px';
        // this.targetElement.style.top = y + 'px';
        // this.targetElement.style.left = x + 'px';
        this.targetElement.style.top = '0px';
        this.targetElement.style.left = '0px';
      }
      this.targetElement.style.position = 'absolute';
      this.targetElement.style['transform-origin'] = '50% 50%';
      this.targetElement.style.transform = `rotate(${this.rotate}deg)`;
    }
  }
};
</script>

<style scoped lang="scss">
.cropper-box {
  position: relative;
  width: 100%;
  height: 100%;
  //background-color: #fff;
  border: 0px solid black;
  margin: 0px;
  overflow: hidden;

  // & > :first-child {
  //   // max-width: 100%;
  //   // max-height: 100%;
  //   position: absolute;
  //   left: 0;
  //   top: 0;
  //   transform-origin: 50% 50%;
  // }
}

.cut-side {
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
}

.cut-window {
  position: absolute;
  overflow: hidden;
  background: linear-gradient(to bottom, transparent calc(100% - 2px), rgba(139, 162, 255, 0.4) calc(100% - 1px)),
    linear-gradient(to right, transparent calc(100% - 2px), rgba(139, 162, 255, 0.4) calc(100% - 1px));
  background-size: 33.33% 33.33%;

  box-shadow: 0 0 0 9999px rgba(255, 255, 255, 0.8);
  cursor: move;

  .west-side {
    position: absolute;
    left: 0px;
    top: 0px;
    height: 100%;
    width: 2px;
    cursor: w-resize;
    background: #2f58fe;

    // > div {
    //   position: absolute;
    //   left: 0px;
    //   top: 0px;
    //   width: 2px;
    //   height: 100%;
    //   background: #2f58fe;
    // }
  }
  .north-side {
    position: absolute;
    left: 0px;
    top: 0px;
    height: 2px;
    width: 100%;
    cursor: n-resize;
    background: #2f58fe;

    // > div {
    //   position: absolute;
    //   left: 0px;
    //   top: 0px;
    //   height: 2px;
    //   width: 100%;
    //   background: #2f58fe;
    // }
  }
  .esat-side {
    position: absolute;
    right: 0px;
    top: 0;
    height: 100%;
    width: 2px;
    cursor: e-resize;
    background: #2f58fe;

    // > div {
    //   position: absolute;
    //   right: 0px;
    //   top: 0px;
    //   height: 100%;
    //   width: 2px;
    //   background: #2f58fe;
    // }
  }
  .south-side {
    position: absolute;
    left: 0px;
    bottom: 0px;
    height: 2px;
    width: 100%;
    cursor: s-resize;
    background: #2f58fe;

    // > div {
    //   position: absolute;
    //   left: 0px;
    //   bottom: 0px;
    //   height: 2px;
    //   width: 100%;
    //   background: #2f58fe;
    // }
  }
  .west-north-side {
    position: absolute;
    top: 0;
    left: 0;
    width: 26px;
    height: 26px;
    border-top: 4px solid #2f58fe;
    border-left: 4px solid #2f58fe;
    cursor: nw-resize;
  }
  .east-north-side {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 26px;
    height: 26px;
    border-top: 4px solid #2f58fe;
    border-right: 4px solid #2f58fe;
    cursor: ne-resize;
  }
  .east-south-side {
    position: absolute;
    bottom: 0px;
    right: 0px;
    width: 26px;
    height: 26px;
    border-right: 4px solid #2f58fe;
    border-bottom: 4px solid #2f58fe;
    cursor: se-resize;
  }
  .west-south-side {
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 26px;
    height: 26px;
    border-bottom: 4px solid #2f58fe;
    border-left: 4px solid #2f58fe;
    cursor: sw-resize;
  }
}
</style>
